import { render, staticRenderFns } from "./VesselActivityForm.vue?vue&type=template&id=bc085a5a&"
import script from "./VesselActivityForm.vue?vue&type=script&lang=js&"
export * from "./VesselActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports